import Vue from 'vue';
//sessionStorage.getItem('chufadi','');
//sessionStorage.getItem('mudedi','');

Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === 'chufadi') {
 
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);
 
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
 
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
 }
 window.resetSetItem= function resetSetItem(key, newVal) {
    if (key === 'chufadi') {
 
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);
 
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
 
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
 }


 Vue.prototype.resetSetItem1=function (key, newVal) {
    if (key === 'mudedi') {
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem1: function (k, val) {
                sessionStorage.setItem(k, val);
 
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem1', false, false, k, null, val, null, null);
 
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem1(key, newVal);
    }
 }


window.resetSetItem1= function resetSetItem1(key, newVal) {
    if (key === 'mudedi') {
 
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem1: function (k, val) {
                sessionStorage.setItem(k, val);
 
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem1', false, false, k, null, val, null, null);
 
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem1(key, newVal);
    }
}
 window.fShowMapCallback = fShowMapCallback;
 

function fShowMapCallback(name, lng, lat,type){
   
    let sName = name + "(" + lng + "," + lat + ")";

    if (type === "1") {
        resetSetItem1('mudedi', sName)
    }
    else {
        resetSetItem('chufadi', sName)
    }        
}